export { CheckmarkSmallIcon } from './CheckmarkSmallIcon'
